import React from 'react';
import styled, { css, createGlobalStyle } from 'styled-components';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { title } from '../../../../theme/typography';
import { colors, headerSize } from '../../../../theme/styled';
import { media } from '../../../../theme/media';
import downIcon from '../../../../images/arrow-expand-down.svg';

export const Animations = createGlobalStyle`
  @keyframes down-and-out {
    0% {
      transform: translateY(-5px) translateX(-50%);
      opacity: 1;
    }
    99% {
      transform: translateY(20px) translateX(-50%) scaleY(1);
      opacity: 0;
    }
    100% {
      transform: translateY(20px) translateX(-50%) scaleY(0);
    }
  }

  @keyframes up-and-in {
    0% {
      opacity: 0;
      transform: translateY(20px) translateX(-50%);
      display: block;
    }
    100% {
      transform: translateY(-5px) translateX(-50%);
      opacity: 1;
    }
  }
`;

export const MenuLinkTitle = styled.p`
  ${title};
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  color: ${colors.white};

  ${media.desktop`
    font-size: 14px;
  `};

  ${props =>
    props.dropdown &&
    css`
      &:before {
        content: '';
        position: absolute;

        background-image: url(${downIcon});
        background-position: center;
        width: 20px;
        height: 20px;
        right: -25px;
      }
    `}

  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 2px;
    display: block;
    bottom: -9px;
    background-color: ${colors.white};
    transform: scaleX(0);
    transition: transform 0.2s ease-in-out;
  }
`;

// NavLink passes props down to dom object, causing errors in react. This filters out irrelevant properties.
const NavLinkWithRelevantProps = ({ children, to, className }) => (
  <NavLink className={className} to={to}>
    {children}
  </NavLink>
);

NavLinkWithRelevantProps.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
};

export const MenuLink = styled(NavLinkWithRelevantProps)`
  padding: 0 24px;
  height: ${headerSize.mobile}px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  ${media.desktopSmall`
    height: ${headerSize.desktop}px;
    padding: 0 ${props => (props.isFeatured ? 36 : 20)}px;
  `};

  &.active {
    ${MenuLinkTitle}:after {
      transform: ${props => (props.isFeatured ? 'scaleX(0)' : 'scaleX(1)')};
    }
  }

  &:focus {
    outline: ${props => (props.isFeatured ? `2px solid ${colors.yellow}` : 'none')}
      ${MenuLinkTitle}:after {
      transform: ${props => (props.isFeatured ? 'scaleX(0)' : 'scaleX(1)')};
    }
  }
`;

export const MenuLinkExternal = styled(MenuLink).attrs({ as: 'a' })``;

export const MenuListItem = styled.li`
  background-color: ${props => {
    if (!props.isFeatured) {
      return 'transparent';
    }
    return props.useSecondaryColor ? colors.yellow : colors.accessibilityRed;
  }};

  * {
    color: ${props => (props.useSecondaryColor ? colors.darkGrey : '')};
  }

  margin-left: ${props => (props.isFeatured ? '19px' : 0)};
  position: relative;

  ${media.mobile`
    margin-left: ${props => (props.isFeatured ? '20px' : 0)};
  `};

  ${MenuLink} {
    letter-spacing: ${props => (props.isFeatured ? '1px' : '2px')};
  }

  &.hovered {
    background-color: ${props => {
    if (!props.isFeatured) {
      return 'transparent';
    }
    return props.useSecondaryColor ? colors.hoverYellow : colors.hoverRed;
  }};

    ${MenuLinkTitle}:after {
      transform: ${props => (props.isFeatured ? 'scaleX(0)' : 'scaleX(1)')};
    }
  }
`;
